// extracted by mini-css-extract-plugin
module.exports = {"statusBadge":"TicketStatusBadge_statusBadge__2HXns"};